<template>
    
    <div class="g-container">
        <div class="m-container m-width">
            <!--面包屑-->
            <div class="crumbs-box">
                <router-link tag="a" class="c-crumbs" :to="{name:'mallIndex'}">云商城</router-link>
                <span class="c-sep">&gt;&gt;</span>
                <!--{{detail.title}} -->
                <span class="c-current">产品名称</span>
            </div>
            <div>
                <detail-edit @delCheckFun='list(arguments)' ref="detailEdit"></detail-edit>
            </div>
            
        <!--产品案例-带图卡片-->
        <div class="mall-preview" v-show='onshow' style='display:inline-block;margin-top:30px;'>
            <div class="goods-preview">
                <div class="shop_tit margin30">
                    <i class="fan_img"></i>
                    <div class="shop_tit deta_tit">产品案例</div>
                </div>
                 <div class="goods-preview-inner" style='display:inline-block'>
                    <div v-for="(items,index) in imgList" :key="index" class="maLeft25 flostleft" @click.stop="onimgList($event,items,index)">
                        <div class="gou_div flex">
                            <!--:class="{'ba_hook':spanIndex.indexOf(index)>-1}"-->
                            <i  class="gou hui_hook1" :id="'img'+index" :class="{'ba_hook' : items.state==true}"></i>
                            <span>勾选将隐藏此案例</span>
                        </div>
                        <!--:id="'btnB'+index"  :class="spanIndex.indexOf(index)>-1 ? 'onbor':'nobor'"-->
                        <div class="bor" :id="items.Id" :class="{'onbor' : items.state==true}">
                            <div class="case-pic">
                                <img class="tu"  alt="" :src="items.bgImg">
                                <div class="tag" style='width: 258px'><span v-for='(sub,typeIndex) in items.tags' class=" tag_left">{{sub}}</span></div>
                                
                            </div>
                            <div class="case-handle">
                                <b class="tag-view">{{items.Title}}</b>
                            </div>                            
                        </div>
                    </div>
                 </div>
            </div>
        </div>
        <div class="baocun" v-show='onshow'>
            <div class="baobtn" @click="baoImg">保存此面板信息</div>
        </div>
         <!--产品详情 -->
         <div class="minwidth" v-show='onshow1'>
            <div class="mall-preview910">
                <div class="goods-preview">
                    <div class="shop_tit margin30">
                        <i class="shop_leix"></i>
                        <div class="shop_tit deta_tit">产品详情</div>
                    </div>
                    <div class="baFAFAFA">
                        <div class="upload" @click='fullUp'>
                            <i class='enlarge'></i><br>
                            <span>图片撑满</span>
                        </div>
                        <div class="upload" @click='original'>
                            <i class='narrow'></i><br>
                            <span>图片原尺寸</span>
                        </div>
                        <div class="upload">
                            <i class='deltu' @click='delImg(kapianNum)'></i><br>
                            <span>删除图片</span>
                        </div>
                        <div class="upload wrap" :class="{'disa':!disableds}">
                            <input v-if="!disableds" type="file" class="file getImgUrl_file"   @change="changeUrl($event,1)" name="filer" accept="image/*" ref="topImgFileInput" disabled/>
                            <input v-else type="file" class="file getImgUrl_file"   @change="changeUrl($event,1)" name="filer" accept="image/*" ref="topImgFileInput"/>
                            <i :class="disableds ? 'Topinsert':'Topinsertfff'"></i><br>
                            <span :class="{'colors':!disableds}">上方插入</span>
                        </div>
                        <div class="upload wrap">
                            <input type="file" class="file getImgUrl_file"  @change="changeUrl($event,2)" name="filer" accept="image/*" ref="leftImgFileInput"/>
                            <i class='botinsert'></i><br>
                            <span>下方插入</span>
                        </div>
                    </div>
                    <div style="background: #fff;text-align: center;" >
                        <div v-for="(item,i) in images" :key="i" class='pdiv'>
                            <span :class="kapianNum ==i ? 'baImg' :'baImgfff'">
                            <!-- :id="'imgbtn'+i" -->
                                <img :class="item.type==1 ? 'fullUp':'original'"  alt="图片炸了" style="max-width:100%;object-fit: cover;" :src="item.pic" @click="onimg(item,i)" >
                            </span>
                            
                        </div>
                    </div>
                    <div  class="baocun width880" @click="baoToPClick">
                        <div class="baobtn hold">保存此面板信息</div>
                    </div>
                    
                </div>
            </div>
            <!--资讯热线 -->
            <div class="mall-pre" v-show='onshow'>
                <div class="bapre">
                    <div class="shop_tit">
                        <div class="title">咨询热线</div>
                    </div>
                    <div class="shouji">
                        <i class="rexian"></i>
                        <span>{{phop}}</span>
                    </div>
                    <div class="maTop" v-if="weixinImg">
                        <div class="title paLeft">微信联系</div>
                        <div class="image">
                        <img class="qrcode_iduilv_2" :src="weixinImg" alt="">
                        </div>
                    </div>
                   <!-- <div class="maTop">
                        <div class="title paLeft maTop15">预约咨询</div>
                        <div class="image_input">
                            <input type="text" placeholder="请输入手机号码" v-model="offerPhone" :id="offerInput ? 'redoffer':'oInput'">
                            <span v-if="offerInput" class="offerred">请输入正确的手机号</span>
                        </div>
                    </div>
                    <div class="btn" @click="offer">
                        <input type="button" value="为我报价" class="btnInput">
                    </div>
                    <div class="zhuyi">注：预约后商家会尽快回电与您联系，请保证电话真实通畅</div>
                </div>
                <div class="weixing">
                
                    <div><i class="qrcode_iduilv_3"></i></div>
                    <div><span>扫一扫，手机浏览本产品</span></div>-->
                </div>
            </div>
        </div>
        </div>
        
        <div style="height:80px;background: #f5f7fa;"> </div>
        
    </div>
</template>

<script>


import '../../../../html/pages/mall/details/details.scss';

import '../../../../html/pages/mall/details/details.css';
import '../../../../html/pages/mall/details/detailBack.css';
import detailEdit from './components/detail-edit';


import { Upload,GetCasesById,SaveStoreInfo,SaveCasesId,Details } from '../../../../api/index.js';
export default {
    name: 'detailBack',
    components: {
        detailEdit
    },
    data() {
        return {
            kapianNum:-1,
            imgList:[],       
            spanIndex:[0],
            id:-1,
            images:[],
            disableds:false,
            onshow:false,
            onshow1:false,
            DataId:'',
            kapiantype:'',
            offerPhone:'',
            offerInput:false,
            phop:'',
            weixinImg:'',
            CasesList:[],
            CaseIds:''
        };
    },
    methods: {       
        //图片卡片
        onimgList(e,item,index){ 
            // let arrIndex = this.spanIndex.indexOf(index);
            // if(arrIndex>-1){
            //     this.spanIndex.splice(arrIndex,1);
            // }else{
            //     this.spanIndex.push(index);
            // }
             item.state = !item.state
            if(item.state){
                this.CasesList.push(item.Id)
            }else{
                this.CasesList.forEach(function(items,indexs,arr){
                    if(items == item.Id){
                        arr.splice(indexs,1)
                    }
                })
            }
        },
        async baoImg(){
            var list = []
            var bao = document.getElementsByClassName('bor')
            for(var i = 0;i <bao.length;i++){
                if(bao[i].className=='bor'){
                    list.push(bao[i].id)
                }
            }
            var caseIds = ""
            for(var j = 0; j < list.length; j++) {
                caseIds += list[j] + ","
            }
            if(caseIds.length > 0) {
                caseIds = caseIds.substr(0, caseIds.length - 1);
            }
            let res = await SaveCasesId({
                id: this.DataId,
                caseIds:caseIds
            });
            if(res.Type == 'Success'){
                this.$message({message: res.Content,type: 'success'});
            }else{
                this.$message.error(res.Content);
            }
        },
        onimg(item,i){
            this.disableds=true
            this.kapiantype = item.type
            this.kapianNum = i
        },
        //撑满
        fullUp(){
            if(this.disableds==true){
                var _this = this
                this.images.forEach(function(item,i,arr){
                    if(_this.kapianNum == i){
                        item.type=1
                    }
                })
            }else{
                this.$message('请选中一张图片');
            }
            
        },
        //原尺寸
        original(){
            if(this.disableds==true){
                var _this = this
                this.images.forEach(function(item,i,arr){
                    if(_this.kapianNum == i){
                        item.type=2
                    }
                })
            }else{
                this.$message('请选中一张图片');
            }
            
        },
        //删除图片
        delImg(i){
            if(i !=-1){
                this.images.splice(i, 1);
            }else{
                this.$message('请选中一张图片');
            }
        },
        //上传图片接口
        async changeUrl(eve,e){
            var that = this
            let files = ''
            if(e == '1'){
                if(that.kapianNum !=-1 ){
                    this.disableds = true
                    files = that.$refs.topImgFileInput.files[0]
                    let res = await Upload({
                        file: files,
                    });
                    if(res.Type == 'Success'){
                        if(that.images == null){
                            that.images = [];
                        }
                        that.images.splice(that.kapianNum, 0,{'pic':res.Data,'type':2})
                    }else{
                        that.$message(res.Content);
                    }
                }
                
            }else if(e == '2'){
                var that = this
                if(that.kapianNum != -1){
                    files = that.$refs.leftImgFileInput.files[0]
                    let res = await Upload({
                        file: files,
                    });
                    if(res.Type == 'Success'){
                        if(that.images == null){
                            that.images = [];
                        }
                        that.images.splice(that.kapianNum+1, 0, {'pic':res.Data,'type':2})
                    }else{
                        that.$message(res.Content);
                    }
                }else{
                    files = that.$refs.leftImgFileInput.files[0]
                    let res = await Upload({
                        file: files,
                    });
                    if(res.Type == 'Success'){
                        console.log(that.images)
                        if(that.images == null){
                            that.images = [];
                        }
                        that.images.push({'pic':res.Data,'type':2});
                    }else{
                        that.$message(res.Content);
                    }
                }
                
            }
            
        },
        async baoToPClick(){
            let res = await SaveStoreInfo({
                id: this.DataId,
                proDetail:JSON.stringify(this.images)
            });
            if(res.Type == 'Success'){
                this.$message({message: res.Content,type: 'success'});
            }else{
                this.$message.error(res.Content);
            }
        },
        list(data){
            this.DataId = data[0]
            this.phop = data[1]
            this.weixinImg = data[2]
            this.onshow = true
            this.onshow1 = true
            this.GetCasesById()
        },
        async GetCasesById(){
            var _this = this
            let res = await GetCasesById({
                id: this.DataId
            });
            if(res.Type == 'Success'){
                res.Data.forEach(function(item){
                    _this.$set(item,'state',false);
                })
                this.imgList = res.Data
                this.imgList.forEach(function(txt){
                    if(_this.CaseIds !=''){
                        if(_this.CaseIds.indexOf(`${txt.Id}`) == -1){
                            txt.state =true
                        }
                    }
                })
            }
        },
        async Update(){
            var _this = this
            let res = await Details({
                id: this.DataId
            });
            if(res.Type == 'Success'){
                var data = res.Data.good
                if(data.CaseIds !=null){
                    this.CaseIds = data.CaseIds.split(',')
                }
                 
                this.GetCasesById()
                this.images = JSON.parse(data.ProDetail)
                this.weixinImg = data.QRCode
                this.phop = data.Phone
                this.onshow = true
                this.onshow1 = true
            }
        }
    },
    created() {
        if(this.$route.query.id){
            this.DataId =this.$route.query.id
            this.Update()
        }
        
    }
}
</script>

<style>
</style>
